import {t} from "@lingui/core/macro";
import React, {Fragment, useEffect, useState} from "react";
import {FilePdfOutlined,GlobalOutlined} from "@ant-design/icons"
import {Alert, Button, Divider, Form, Input, Upload} from "antd";

export default {
    Renderer: (props) => {
        const data=props.data

        return(
            <div>
                {data.url && (
                    <iframe src={data.url} frameBorder={"no"} style={{width:"100%",height:data.height}}/>
                )}

                {!data.url && (
                    <Alert showIcon type={"warning"} message={t`Veuillez saisir une URL.`}/>
                )}
            </div>
        )

    },
    id: 'iframe',
    title: 'Page incrusté',
    description: "Incruster une url de votre choix",
    icon: <GlobalOutlined />,
    version: 1,
    allowClickInside:true,
    controls:{
        type: 'autoform',
        schema: {
            properties: {
                url: {
                    type: 'string',
                    uniforms: {
                        required: true,
                        label: "Url de la page",
                        placeholder: "https://...",
                    }
                },

                height: {
                    type: 'number',
                    uniforms: {
                        required: true,
                        label: "Hauteur",
                        placeholder: "Hauteur",
                    }
                },
            }
        }
    }
}
